<template>
  <d-card class="card-small mb-4">

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form @submit="checkForm">
              <d-form-row>

                <!-- First Name -->
                <d-col md="12" class="form-group">
                  <label for="feFirstName">Nome</label>
                  <d-form-input type="text" name="feFirstName" id="feFirstName" v-model="feFirstName" placeholder="Nome" />
                </d-col>

              </d-form-row>

              <d-form-row>

                <!-- Email -->
                <d-col md="6" class="form-group">
                  <label for="feEmail">Email</label>
                  <d-form-input type="email" id="feEmail" v-model="feEmail" placeholder="Email" />
                </d-col>

                <!-- Password -->
                <d-col md="6" class="form-group">
                  <label for="fePassword">Senha</label>
                  <d-form-input type="password" id="fePassword" v-model="fePassword" placeholder="Senha" />
                </d-col>

              </d-form-row>

              <d-form-row>

                <!-- CPF -->
                <d-col md="4" class="form-group">
                  <label for="cpf">CPF</label>
                  <d-form-input type="text" id="cpf" v-mask="'###########'" v-model="cpf" placeholder="CPF" />
                </d-col>
                <d-col md="4" class="form-group">
                  <label for="cell">Celular</label>
                  <d-form-input type="text" id="cell" v-mask="'###########'" v-model="cell" placeholder="Telefone / celular" />
                </d-col>
                <d-col md="4" class="form-group">
                  <label for="birth_date">Data de nascimento</label>
                  <d-form-input type="text" id="birth_date" v-mask="'##-##-####'" v-model="birth_date" placeholder="Data de nascimento" />
                </d-col>

              </d-form-row>
              <div class="message-error" v-if="errorCustom === 1">
                Preencha todos os campos acima!
              </div>
              <div style="text-align:right;" v-if="!loading">
                <d-button type="submit" class="btn-accent">Atualizar</d-button>
              </div>
              <div style="text-align:right;" v-if="loading">
                <img src="/images/load2.gif" style="height: 20px;" />
              </div>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</template>

<script>
import axios from 'axios'
import config from '../../config'
import {mask} from 'vue-the-mask'
import {setCookie, getCookie} from '../../utils'
export default {
  name: 'user-account-details',
  directives: {mask},
  data() {
    return {
      errorCustom: 0,
      feFirstName: null,
      feEmail: null,
      fePassword: null,
      cpf: null,
      cell: null,
      birth_date: null,
      loading: false,
    };
  },
  beforeMount(){
    this.getData();
  },
  methods: {
    getData() {
      axios.get(config.serverUrl + '/v1/user', {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          this.feFirstName = res.data.user.name;
          this.feEmail = res.data.user.email;
          this.fePassword = null;
          this.cpf = res.data.user.cpf;
          this.cell = res.data.user.phone;
          let tempBirth = ''
          if (res.data.user.birth_date) {
            let tempBirth2 = res.data.user.birth_date.split('T')
            let tempBirth3 = tempBirth2[0].split('-')
            tempBirth = tempBirth3[2] + '-' + tempBirth3[1] + '-' + tempBirth3[0]
          }
          this.birth_date = tempBirth;
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    checkForm(e) {
      e.preventDefault();
      if (!this.feFirstName || !this.feEmail || !this.cpf || !this.cell || !this.birth_date) {
        this.errorCustom = 1;
        return false;
      }
      this.loading = true
      axios.put(config.serverUrl + '/v1/user',
      {
        name: this.feFirstName,
        email: this.feEmail,
        password: this.fePassword,
        cpf: this.cpf,
        phone: this.cell,
        birth_date: this.birth_date
      },
      {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        this.loading = false
        if (res.data.response) {
          setCookie('name-client', this.feFirstName, 2);
          setCookie('email-client', this.feEmail, 2);
          alert('Dados atualizados com sucesso')
          location.reload()
        }
      })
      .catch((error) => {
        this.loading = false
        console.log(error)
      })
      return false;
    },
  },
};
</script>
